import { Form, FormFieldType } from "@/forms/Form";

export class WorkOrderSketchDataForm extends Form {
  public definition = {
    signature: { required: true, type: FormFieldType.Text }
  };
}
